import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';

import {
  style,
  trigger,
  transition,
  animate
} from '@angular/animations';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { SkyMediaQueryService } from './../media-queries/media-query.service';

import {
  SkyVerticalTabsetService,
  VISIBLE_STATE
} from './../vertical-tabset/vertical-tabset.service';


export class SkySectionedFormComponent implements OnInit, OnDestroy, AfterViewChecked {

  
  public indexChanged: EventEmitter<number> = new EventEmitter();

  
  public content: ElementRef;

  private _ngUnsubscribe = new Subject();

  constructor(
    public tabService: SkyVerticalTabsetService,
    private changeRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.tabService.indexChanged
      .takeUntil(this._ngUnsubscribe)
      .subscribe(index => {
        this.indexChanged.emit(index);
        this.changeRef.markForCheck();
      });

    this.tabService.switchingMobile
      .takeUntil(this._ngUnsubscribe)
      .subscribe((mobile: boolean) => this.changeRef.detectChanges());

    if (this.tabService.isMobile()) {
      this.tabService.animationVisibleState = VISIBLE_STATE;
    }
  }

  public ngAfterViewChecked() {
    this.tabService.content = this.content;
    this.tabService.updateContent();
  }

  public ngOnDestroy() {
    this._ngUnsubscribe.next();
    this._ngUnsubscribe.complete();
  }

  public tabsVisible() {
    return this.tabService.tabsVisible();
  }

  public showTabs() {
    this.tabService.showTabs();
    this.changeRef.markForCheck();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-sectioned-form',
  template: `<div class="sky-sectioned-form" (window:resize)="tabService.updateContent()">
  <div 
    *ngIf="tabsVisible()"
    class="sky-sectioned-form-tabs"
    [@tabEnter]="tabService.animationVisibleState"
  >
    <ng-content></ng-content>
  </div>
  <div 
    #skySectionSideContent 
    *ngIf="tabService.contentVisible()"
    class="sky-sectioned-form-content"
    [@contentEnter]="tabService.animationVisibleState"
  >
  </div>
</div>

`,
  styles: [`.sky-sectioned-form-content {
  padding: 15px;
}

@media (min-width: 768px) {
  .sky-sectioned-form {
    display: flex;
  }
  .sky-sectioned-form-tabs {
    flex-basis: 30%;
    border-right: 1px solid #e2e3e4;
  }
  .sky-sectioned-form-content {
    flex-basis: 70%;
  }
}
`],
  providers: [SkyVerticalTabsetService, SkyMediaQueryService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'tabEnter', [
        transition(`void => ${VISIBLE_STATE}`, [
          style({transform: 'translate(-100%)'}),
          animate('150ms ease-in')
        ])
      ]
    ),
    trigger(
      'contentEnter', [
        transition(`void => ${VISIBLE_STATE}`, [
          style({transform: 'translate(100%)'}),
          animate('150ms ease-in')
        ])
      ]
    )
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyVerticalTabsetService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'indexChanged': [{ type: Output },],
'content': [{ type: ViewChild, args: ['skySectionSideContent', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
